<h1 mat-dialog-title>Criteria</h1>
<mat-dialog-content>

  <h2 cdkFocusInitial style="font-size: 2em;">ESSENTIAL CRITERIA for inclusion in Fáilte Ireland’s Events Database</h2>

  <p>Fáilte Ireland’s database of events is a bank of key events and festivals taking place in
    the Republic of Ireland.</p>

  <p>We proactively gather and collate detailed information on one-time, annual, seasonal or
    infrequently occurring events that are of a quality and scale to specifically target and attract overseas and/or
    non-local visitors to the area they are being staged in.</p>

  <p>The information is gathered by Fáilte Ireland for the purpose of promoting these events
    on <u><i>any or all</i></u> of the websites owned & managed by Fáilte Ireland and Tourism Ireland where applicable.
  </p>

  <p>Fáilte Ireland retain the right not to accept or publish or promote events from the
    database if they fall outside our eligibility criteria below.</p>

  <br />

  <h2 style="font-size: 2em;">Eligibility Criteria – Please read carefully </h2>

  <ul>
    <li>
      <p>The Event should provide an attendee with a great leisure, social, sporting or
        cultural experience outside of the normal range of everyday or regular choices.</p>
    </li>
    <li>
      <p>It can be a one-time, annual, seasonal or infrequently occurring.</p>
    </li>
    <li>
      <p>It should be of a quality and scale, fee paying or free.</p>
    </li>
    <li>
      <p>It should be relevant to the tourism industry so that we can use it to promote
        Ireland to attract overseas and/or non-local visitors to the area it is being staged in.</p>
    </li>
    <li>
      <p>It should have a pre-determined opening and closing date/time.</p>
    </li>
    <li>
      <p>It should be open to the community at large and to all visitors to the area (so not a
        closed "by invitation only" event).</p>
    </li>
    <li>
      <p>An event meeting all other criteria, should also fall within one of the following
        categories: Festival, Culture, Heritage; Literature, Film, Art; Music, Dance, Major Theatre; Sports & Outdoor;
        Food & Drink; Agriculture; Special interest.</p>
    </li>
    <li>
      <p>Events may only be submitted by the Event Organisers and not by any third party.</p>
    </li>
    <li>
      <p>Events must have a digital presence where attendees can find out more about the event
        or book tickets this can be a social media platform or website.</p>
    </li>
  </ul>
  <p>&nbsp;</p>

  <h2 style="font-size: 2em;">Events which are not eligible for inclusion</h2>

  <ul>
    <li>
      <p>Any event that does not meet the above criteria.</p>
    </li>
    <li>
      <p>Events that are by invitation only, including clan or other invitational gatherings
        or tours.</p>
    </li>
    <li>
      <p>Small-scale local events with limited capacity to attract national or international
        visitors to the destination e.g. local community events or sports days aimed at the local communities.</p>
    </li>
    <li>
      <p>Activities/Adventures that are part of commercial packages e.g. packaged walking
        breaks, packaged golf breaks, packaged or regular programmes of activities at activity or adventures centres or
        accommodation. Small-scale add-on events at visitor attractions/galleries such as add-on animation, art
        exhibitions etc. Small sub-events which form part of much larger events or programmes (which will be strongly
        profiled on the Fáilte Ireland suite of websites) e.g. National Heritage Week or Culture Night etc. Art and
        other exhibitions - unless of significant scale, capable of attracting international and national audiences to
        the area they are being staged in.</p>
    </li>
    <li>
      <p>Trade shows, conferences, seminars and small commercial exhibitions that are not
        relevant to leisure tourism.</p>
    </li>
  </ul>

  <br />
  <h2 style="font-size: 2em;">If your event is eligible, it is also essential to comply with the following:</h2>

  <ul style="margin-top: 0cm;">
    <li>
      <p>Only events submitted via <a href="https://www.failteirelandevents.ie"
          target="_blank">www.failteirelandevents.ie</a> form will be promoted through Fáilte Ireland websites.</p>
    </li>
    <li>
      <p>The event should be submitted a minimum of 14 days in advance of the event’s start
        date. Events submitted closer may not be considered for inclusion. Events are promoted in the international
        marketplace and intending visitors require information well in advance of travelling to Ireland to help them
        plan their visits.</p>
    </li>
    <li>
      <p>The event’s occurrence must be confirmed (not a provisional event or conditional).
      </p>
    </li>
    <li>
      <p>The event information submitted must be concise, but still highly informative. To be
        considered, submissions must be well written and carefully checked for spellings and grammar.</p>
    </li>
  </ul>

  <p><b>The event entry at a minimum should include the following information to be published
      on the event listing and our consumer sites:</b></p>
  <ul>
    <li>
      <p>
        Event name
      </p>
    </li>
    <li>
      <p>
        Event dates
      </p>
    </li>
    <li>
      <p>
        Event description
      </p>
    </li>
    <li>
      <p>
        High-quality images – we recommend at least three.
      </p>
    </li>
    <li>
      <p>
        An event email address.
      </p>
    </li>
    <li>
      <p>
        A direct link to the event online which users can be directed to for more information. This can be a page on
        your website or a social media page clearly providing more information about the event.
      </p>
    </li>
  </ul>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close type="button">Close</button>
</mat-dialog-actions>